import { format as dateFormat } from "date-fns";
import { es, pt, fr, de, it, nl, ja, ko, tr, da, hi, ar, zhCN, zhHK, enAU } from "date-fns/locale";
import i18next from "i18next";
import { isLocale } from "./utils.js";
const locales = {
  en: enAU,
  es,
  pt,
  fr,
  de,
  it,
  nl,
  ja,
  ko,
  tr,
  da,
  hi,
  ar,
  "zh-CN": zhCN,
  "zh-HK": zhHK
};
const format = (date, format2) => {
  const lang = i18next.language ?? "en";
  return dateFormat(date, format2, {
    locale: isLocale(lang) ? locales[lang] : locales["en"]
  });
};
export {
  format
};
//# sourceMappingURL=date.js.map